import { createAction } from 'redux-actions'

const ns = 'apple-sign-in/'

export const doAppleSignIn = createAction(`${ns}DO_APPLE_SIGN_IN`)
export const doAppleSignInFail = createAction(`${ns}DO_APPLE_SIGN_IN_FAIL`)
